import { render } from "./PatientRegister.vue?vue&type=template&id=25a4cb99&scoped=true"
import script from "./PatientRegister.vue?vue&type=script&lang=js"
export * from "./PatientRegister.vue?vue&type=script&lang=js"

import "./PatientRegister.vue?vue&type=style&index=0&id=25a4cb99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a4cb99"]])

export default __exports__